// src/data/content.js
// MeeChain Network — all static content, chain config, and badge data

export const CHAIN = {
  id: 13390,
  hexId: "0x344e",
  name: "MeeChain Network",
  symbol: "MEE",
  decimals: 18,
  rpcUrls: [
    "https://rpc.meechain.run.place",
    "https://rpc.meechain.live",
    "https://rpc.mainnet.meechain.live",
  ],
  explorerUrl: "https://scan.meechain.live",
  faucetUrl:   "https://faucet.meechain.network",
};

export const NAV_LINKS = [
  { label: "Home",        href: "#",          active: true  },
  { label: "Ecosystem",   href: "#ecosystem"               },
  { label: "Developers",  href: "#builders"                },
  { label: "Explorer",    href: "https://scan.meechain.live", external: true },
  { label: "Docs",        href: "#"                        },
  { label: "Community",   href: "#"                        },
];

export const HERO = {
  title:    "MeeChain",
  subtitle: "Network",
  desc:     "From gameplay to on-chain rewards,\nbadges, staking, and live network tools.",
  buttons: [
    { label: "🚀 LAUNCH APP",      variant: "primary", action: "connectWallet" },
    { label: "🔍 VIEW EXPLORER",   variant: "ghost",   action: "openExplorer"  },
    { label: "⬡ CONNECT WALLET",  variant: "ghost",   action: "connectWallet" },
  ],
  chips: [
    { label: "🔗 Chain 13390", style: "chain" },
    { label: "Ⓜ MEE Token",   style: "mee"   },
    { label: "🏅 NFT Badge",   style: "nft"   },
    { label: "📡 Explorer Live", style: "exp", action: "openExplorer" },
  ],
  orbitalLabelsLeft:  ["PLAY", "EARN", "OWN"],
  orbitalLabelsRight: ["BUILD", "STAKE", "GROW"],
};

export const NETWORK_STATUS = [
  {
    id: "rpc",
    icon: "🌐",
    label: "RPC STATUS",
    value: "99.98%",
    badge: "HEALTHY",
    badgeStyle: "green",
    url: "https://rpc.meechain.live",
    sparkColor: "#34d399",
    liveKey: "blockNumber",
  },
  {
    id: "explorer",
    icon: "🔍",
    label: "EXPLORER STATUS",
    value: "LIVE",
    badge: "OPERATIONAL",
    badgeStyle: "cyan",
    url: "https://scan.meechain.live",
    sparkColor: "#67e8f9",
  },
  {
    id: "api",
    icon: "⚡",
    label: "REWARD API",
    value: "98.7%",
    badge: "HEALTHY",
    badgeStyle: "green",
    url: "https://api.meechain.network",
    sparkColor: "#34d399",
  },
  {
    id: "faucet",
    icon: "💧",
    label: "FAUCET",
    value: "LIVE",
    badge: "AVAILABLE",
    badgeStyle: "cyan",
    url: "https://faucet.meechain.network",
    sparkColor: "#67e8f9",
  },
  {
    id: "contracts",
    icon: "📄",
    label: "ACTIVE CONTRACTS",
    value: "24",
    badge: "VERIFIED",
    badgeStyle: "purple",
    url: "24 Deployed",
    sparkColor: "#a78bfa",
  },
];

export const ECOSYSTEM_FLOW = [
  {
    icon: "🎮",
    iconStyle: "purple",
    label: "PLAYER ACTION",
    desc: "Play, compete,\ncomplete missions",
  },
  {
    icon: "📡",
    iconStyle: "cyan",
    label: "REWARD API",
    desc: "Action verified &\nsent to Reward API",
  },
  {
    icon: "📋",
    iconStyle: "purple",
    label: "GAMEREWARD CONTRACT",
    desc: "Smart contract\nvalidates & records",
  },
  {
    icon: "🟡",
    iconStyle: "amber",
    label: "MEE REWARD",
    desc: "MEE tokens\nminted to player",
  },
  {
    icon: "🏅",
    iconStyle: "green",
    label: "BADGE PROGRESS",
    desc: "Badges updated\n& progress recorded",
  },
];

export const BADGES = [
  {
    id: "bronze",
    tokenId: 1,
    name: "BRONZE",
    rarity: "COMMON",
    icon: "🥉",
    tier: "bronze",
    xp: 100,
    xpBonus: "+5% XP",
    holders: 12450,
    color: "#cd7f32",
  },
  {
    id: "silver",
    tokenId: 2,
    name: "SILVER",
    rarity: "UNCOMMON",
    icon: "🥈",
    tier: "silver",
    xp: 200,
    xpBonus: "+10% XP",
    holders: 8231,
    color: "#9ca3af",
  },
  {
    id: "gold",
    tokenId: 3,
    name: "GOLD",
    rarity: "RARE",
    icon: "🥇",
    tier: "gold",
    xp: 400,
    xpBonus: "+20% XP",
    holders: 4892,
    color: "#fbbf24",
  },
  {
    id: "platinum",
    tokenId: 4,
    name: "PLATINUM",
    rarity: "EPIC",
    icon: "💎",
    tier: "platinum",
    xp: 500,
    xpBonus: "+35% XP",
    holders: 1231,
    color: "#60a5fa",
  },
  {
    id: "legendary",
    tokenId: 5,
    name: "LEGENDARY",
    rarity: "MYTHIC",
    icon: "⭐",
    tier: "legendary",
    xp: 800,
    xpBonus: "+50% XP",
    holders: 321,
    color: "#c084fc",
  },
];

export const BUILDER_TABS = [
  { id: "contracts",  label: "CONTRACTS"   },
  { id: "registry",   label: "REGISTRY"    },
  { id: "abi",        label: "ABI"         },
  { id: "utils",      label: "UTILS"       },
  { id: "multichain", label: "MULTI-CHAIN" },
];

export const CODE_SAMPLES = {
  contracts: {
    contract: "0x3F6a…9C7d",
    network:  "MeeChain (Chain 13390)",
    compiler: "Solidity 0.8.20",
    code: `// GameReward Contract
function claimReward(address player, uint256 amount) external {
  require(isEligible(player), "Not eligible");
  _mint(player, amount);
  emit RewardClaimed(player, amount, block.timestamp);
}`,
  },
  registry: {
    contract: "0x89456efA…aa2",
    network:  "MeeChain (Chain 13390)",
    compiler: "Solidity 0.8.20",
    code: `// Registry Contract
function registerConverter(
  address token, address converter
) external {
  converters[token].push(converter);
  emit ConverterRegistered(token, converter);
}`,
  },
  abi: {
    contract: "0x0d6a54c0…a85",
    network:  "MeeChain (Chain 13390)",
    compiler: "ABI v2",
    code: `// MEE_CHAIN_SUPPLY_ABI
{
  "name": "triggerSupply",
  "type": "function",
  "stateMutability": "nonpayable",
  "inputs": [{ "name": "user", "type": "address" }],
  "outputs": []
}`,
  },
  utils: {
    contract: "encodeABI.ts",
    network:  "All chains",
    compiler: "TypeScript 5.x",
    code: `// encodeABI.ts — no ethers/viem needed
export function encodeCall(sig, ...args) {
  const sel = ABI_SELECTORS[sig];
  return args.reduce((acc, a) =>
    acc + BigInt(a).toString(16).padStart(64,"0"), sel);
}`,
  },
  multichain: {
    contract: "contracts.ts",
    network:  "Multi-chain",
    compiler: "TypeScript 5.x",
    code: `// Multi-chain from contracts.ts
const CHAINS = {
  meechain: { chainId: 13390, rpc: "https://rpc.meechain.run.place" },
  bsc:      { chainId: 56,    rpc: "https://bsc-dataseed.binance.org" },
  polygon:  { chainId: 137,   rpc: "https://polygon-rpc.com" },
};`,
  },
};

export const FEATURES = [
  {
    icon: "⚡",
    title: "Lightning Fast",
    desc: "1,284 TPS with 1.5s block time on MeeChain Network",
    color: "#fbbf24",
  },
  {
    icon: "🔗",
    title: "Multi-Chain",
    desc: "Bridge assets across BSC, Polygon, Arbitrum, and more",
    color: "#60a5fa",
  },
  {
    icon: "🏅",
    title: "NFT Badges",
    desc: "Earn on-chain badges via gameplay and contributions",
    color: "#c084fc",
  },
  {
    icon: "💰",
    title: "MEE Staking",
    desc: "Stake MEE tokens and earn rewards with 21 validators",
    color: "#34d399",
  },
  {
    icon: "🎮",
    title: "Play-to-Earn",
    desc: "MEE Block Runner and more games with on-chain rewards",
    color: "#f97316",
  },
  {
    icon: "🛡️",
    title: "Secure & Verified",
    desc: "24 verified contracts, Slither audited, 90%+ test coverage",
    color: "#a78bfa",
  },
];

export const ROADMAP = [
  {
    phase: "Phase 1",
    label: "Foundation",
    status: "done",
    items: ["Chain 13390 launch", "MEE Token (ERC20)", "Faucet + Explorer", "Badge NFT contracts"],
  },
  {
    phase: "Phase 2",
    label: "Ecosystem",
    status: "active",
    items: ["MEE Block Runner game", "Badge Gallery dApp", "Wallet integration", "Multi-chain bridge"],
  },
  {
    phase: "Phase 3",
    label: "Scale",
    status: "upcoming",
    items: ["DAO Governance", "Mobile app", "DEX launch", "Cross-chain staking"],
  },
  {
    phase: "Phase 4",
    label: "Mainnet",
    status: "upcoming",
    items: ["Full mainnet launch", "CEX listings", "SDK release", "Developer grants"],
  },
];

export const FAQ = [
  {
    q: "MeeChain คืออะไร?",
    a: "MeeChain เป็น EVM-compatible blockchain บน Chain ID 13390 ที่รวม gameplay, NFT badges, staking และ on-chain rewards เข้าด้วยกัน",
  },
  {
    q: "ทำไมต้องใช้ Chain 13390?",
    a: "MeeChain (13390) ออกแบบมาเพื่อ gaming และ DeFi โดยเฉพาะ มี TPS สูง block time 1.5s และค่า gas ต่ำมาก",
  },
  {
    q: "จะได้รับ MEE token ได้อย่างไร?",
    a: "รับ MEE ได้จาก Faucet (testnet), เล่นเกม MEE Block Runner, stake tokens, หรือ contribute และรับ badge NFT",
  },
  {
    q: "Badge NFT ใช้ทำอะไรได้บ้าง?",
    a: "Badge NFT ให้ XP bonus สูงสุด +50%, unlock ฟีเจอร์พิเศษ, แสดงใน badge gallery และใช้ใน governance voting",
  },
];

export const FOOTER_STATS = [
  { label: "MEE TOKEN",     value: "$MEE"             },
  { label: "TOTAL SUPPLY",  value: "1,000,000,000"    },
  { label: "STAKED",        value: "320,421,880 MEE", green: true },
  { label: "VALIDATORS",    value: "21"               },
  { label: "TPS (LIVE)",    value: "1,284",           green: true, liveKey: "tps" },
  { label: "BLOCK TIME",    value: "1.5s"             },
  { label: "GOVERNANCE",    value: "Coming Soon",     muted: true },
];

export const SOCIAL_LINKS = [
  { icon: "𝕏",  label: "Twitter",  href: "#" },
  { icon: "⬡",  label: "Discord",  href: "#" },
  { icon: "✈",  label: "Telegram", href: "#" },
  { icon: "M",  label: "Medium",   href: "#" },
  { icon: "⌨",  label: "GitHub",   href: "https://github.com" },
];
